export const creatOrderFourth = [
  {
    path: `/CreatOrderFourth`,
    name: `CreatOrderFourth`,
    redirect: `/CreatOrderFourth/fourth`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/CreatOrderFourth/fourth',
        name: '/CreatOrderFourth/fourth',
        component: () => import('@/views/creatorderfourth/CreatOrderFourth')
      }
    ]
  }
];
